import { makeStyles, Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { COLOR_BACKGROUND_WARM, COLOR_BLACK, COLOR_ORANGE, COLOR_MIDDLE_GRAY } from '../styles/colors'
import Evaluation from '../organisms/Evaluation'
import clsx from 'clsx'
import Player from '../types/Player'

type TabItem = {
  label: string
  value: string
  disabled?: boolean
}

interface TabPanelProps {
  tabsList: TabItem[],
  selectedTab?: string,
  setSelectedTab?: React.Dispatch<React.SetStateAction<string>>,
  hideEvaluation?: boolean,
  player?: Player
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    maxWidth: '100%',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  tabsWrapperBorder: {
    border: `2px solid ${COLOR_MIDDLE_GRAY}`,
    borderRadius: '30px',
  },
  tabsWrapper: {
    backgroundColor: COLOR_BACKGROUND_WARM,
    display: 'inline-flex',
    minHeight: 'auto',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
    },
  },
  flexContainer: {
    gap: '20px !important'
  },
  tab: {
    borderBottom: `4px solid transparent`,
    color: COLOR_BLACK,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    margin: `${theme.spacing(0)}px`,
    minWidth: 'auto',
    padding: 0,
    textTransform: 'none',

    '&:hover': {
      borderBottom: 'none',
      color: COLOR_BLACK,  
    },

    '&[disabled]': {
      opacity: 0.3,
    },
  },
  selectedTab: {
    borderBottom: `4px solid ${COLOR_ORANGE}`,
    fontWeight: 700,

    '&:hover': {
      borderBottom: `4px solid ${COLOR_ORANGE}`,
    },
  },
  indicator: {
    display: 'none',
  },
}), { name: TabPanel.name });

export default function TabPanel(props: TabPanelProps) {
  const {
    tabsList,
    selectedTab = '',
    setSelectedTab = () => {},
    hideEvaluation = false,
    player,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Tabs
        classes={{
          root: clsx(classes.tabsWrapper, !hideEvaluation && classes.tabsWrapperBorder),
          flexContainer: classes.flexContainer,
          indicator: classes.indicator,
        }}
        variant="scrollable"
        scrollButtons="off"
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value as string)}
        aria-label="tabs"
      >
        {(tabsList ?? []).map((tab) => (
          <Tab
            classes={{
              root: classes.tab,
              'selected': classes.selectedTab
            }}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            wrapped={true}
            disabled={tab.disabled}
            disableRipple
          />
        ))}
      </Tabs>
      {!hideEvaluation && <Evaluation player={player} />}
    </div>
  )
}
